import React, { Component } from 'react'
import { connect } from 'react-redux'
import '../../../styles/checkout/mainStyle.css'
import { toggleDisplayIframe, setShowCalllback, setNotShowCalllback } from '../../../actions/checkoutActions'
import  CallBackButton  from '../../../images/CallBackButton.png'
export class CallBack extends Component {
    constructor(props) {
        super(props);
        this.returnCallbackNum = this.returnCallbackNum.bind(this)
    
    }
    returnCallbackNum = () =>{
        let callBacks = this.props.callBackConsole
        if(callBacks.length === 1 && callBacks[0] === "No CallBack Yet"){
            return "0"
        }else{
            return callBacks.length
        }
      }

    render() {
        const {ifShowCallbackConsole,setShowCalllback,setNotShowCalllback } = this.props;
        return (
            <div className="rightContents2">
                <span id="badge">
                    {this.returnCallbackNum()}
                </span>
                 <img id="myCallBack"  src={CallBackButton} alt="Logo" onClick={()=>setShowCalllback()}>                    
                </img>
                <div id="myCallbackModal" className={ifShowCallbackConsole? "model2" : "modalNotShow2"}>
                    <div className="modal-content2">
                        <div className="modal-header2">
                            <span className="close2" onClick={()=>setNotShowCalllback()}>&times;</span>
                            <h3>Callbacks console</h3>
                        </div>
                        <div className="modal-body2" id="modalBody">

                            {this.props.callBackConsole.map((item) => (
                                <pre key={item}>{item}</pre>   
                            ))}
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    const { PreoloadPrequestResponse, ifDisplayIframe, ifShowCallbackConsole,callBackConsole } = state.checkout.main;
    return { PreoloadPrequestResponse, ifDisplayIframe, ifShowCallbackConsole,callBackConsole };
}

export default connect(mapStateToProps, { toggleDisplayIframe, setShowCalllback, setNotShowCalllback  })(CallBack)
